<template>
  <div>
    <div class="d-flex justify-space-between">
      <h3>Key Visual</h3>
      <FormSwitch v-model="isShow" switchColorClass="brand-500"></FormSwitch>
    </div>
    <div class="py-5">主視覺區塊</div>
    <section>
      <!-- Link -->
      <div class="form-item d-flex py-5">
        <div class="w-180px"><h4>Link</h4></div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="form-input-group">
            <v-icon class="prepend-icon">link</v-icon>
            <input type="text" class="pl-42px" />
          </div>
        </div>
      </div>
      <!-- Image -->
      <div class="form-item d-flex py-5">
        <div class="w-180px">
          <h4>Image</h4>
          <div class="mt-10px h5 ink-02-medium--text">
            建議尺寸：999px * 999px 檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 d-flex justify-end">
          <ImgUploader></ImgUploader>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  components: {
    FormSwitch,
    ImgUploader,
  },
  data: () => ({
    isShow: true,
  }),
};
</script>

<style></style>
